

export class AttendanceSummary implements IAttendanceSummary {
    employeeId!: number;
    rankBy!: number | undefined;
    dayCount!: number | undefined;
    displayName!: string | undefined;
    totalTime!: string | undefined;
    shortCode!: string | undefined;
    showDayCount!: boolean;
    showTime!: boolean;

    constructor(data?: IAttendanceSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.rankBy = _data["rankBy"];
            this.dayCount = _data["dayCount"];
            this.displayName = _data["displayName"];
            this.totalTime = _data["totalTime"];
            this.shortCode = _data["shortCode"];
            this.showDayCount = _data["showDayCount"];
            this.showTime = _data["showTime"];
        }
    }

    static fromJS(data: any): AttendanceSummary {
        data = typeof data === 'object' ? data : {};
        let result = new AttendanceSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["rankBy"] = this.rankBy;
        data["dayCount"] = this.dayCount;
        data["displayName"] = this.displayName;
        data["totalTime"] = this.totalTime;
        data["shortCode"] = this.shortCode;
        data["showDayCount"] = this.showDayCount;
        data["showTime"] = this.showTime;
        return data; 
    }
}

export interface IAttendanceSummary {
    employeeId: number;
    rankBy: number | undefined;
    dayCount: number | undefined;
    displayName: string | undefined;
    totalTime: string | undefined;
    shortCode: string | undefined;
    showDayCount: boolean;
    showTime: boolean;
}

